export const DEFAULTURL = 'https://admin.rialto.kr/';
export const APIURL = 'https://www.rialto.kr:8000/API/';
export const PAGEURL = 'https://www.rialto.kr/'
